module.exports = __webpack_public_path__ + "static/media/fleche jaune-essai.d6c525ca.svg";